import Wrapper from './Wrapper'
import Main from './Main'
import Lesson from './Lesson'
import Statistic from './Statistic'
import History from './History'
import Shop from './Shop'

export default {
	Wrapper,
	Main,
	Lesson,
	Statistic,
	History,
	Shop,
}
